import { TanStackDevtools, TanStackDevtoolsReactPlugin } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';

const plugins: TanStackDevtoolsReactPlugin[] = [
  {
    name: 'TanStack Query',
    render: <ReactQueryDevtoolsPanel />,
  },
  formDevtoolsPlugin(),
];

export const DevTools =
  process.env.NODE_ENV !== 'development'
    ? () => null
    : () => {
        return <TanStackDevtools plugins={plugins} />;
      };
